<template>
    <div style="margin: 10px">
        <v-card>
            <v-toolbar color="primary" dark v-if="!print">
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <form v-if="!print">
                <v-layout wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.area.name')"
                                  v-model.trim="search.areaId"
                                  v-validate="'required'"
                                  :items="lstArea"
                                  name="areaId"
                                  item-text="categoryName"
                                  item-value="categoryId"
                                  @change="getPondSearchList"
                                  clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.pond.name')"
                                  v-model.trim="search.pondId"
                                  :items="lstPond"
                                  name="pondId"
                                  item-text="code"
                                  item-value="pondId"
                                  @change="getCropSearchList"
                                  clearable
                                  multiple
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select
                                :label="$t('lang.crop.name')"
                                v-model.trim="search.cropId"
                                v-validate="'required'"
                                :items="lstCrop"
                                item-text="name"
                                item-value="cropId"
                                name="cropId"
                                @change="changeCrop"
                                clearable
                                multiple
                        />
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker 
                            :label="$t('lang.common.fromDate')"
                            v-model.trim="search.fromDate"
                            v-validate="'date_before_now'"
                            :data-vv-as="$t('lang.common.fromDate')"
                            name="fromDate"
                            :maxDate="maxDay()"
                            :error-messages="errors.first('fromDate')"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker
                            :label="$t('lang.common.toDate')"
                            v-model.trim="search.toDate"
                            v-validate="'required|endDateAfterStart'"
                            :data-vv-as="$t('lang.common.toDate')"
                            name="toDate"
                            :error-messages="errors.first('toDate')"
                        />
                    </v-flex>
                </v-layout>
            </form>
            <table v-else class="infomation infoTable">
                <tr>
                    <td colspan="2" style="text-align: center;width: 100%" class="title">BÁO CÁO TÌNH TRẠNG AO</td>
                </tr>
                <tr>
                    <td><label>Từ ngày:</label> {{search.fromDate | formatDate}}</td>
                    <td><label>Đến ngày:</label> {{search.toDate | formatDate}}</td>
                </tr>
            </table>
            <v-card-text>
                <v-tabs v-if="cropSelected.length >0 ">
                    <v-tabs-slider color="#2196F3"></v-tabs-slider>
                    <v-tab
                            v-for="item in cropSelected"
                            :key="item.cropId"
                    >
                        {{item.name }}
                    </v-tab>
                    <v-tabs-items>
                        <v-tab-item v-for="(item, index) in cropSelected" :key="index">
                            <pond-report-summary :report-data="reportData" :search="search" v-if="item.cropId == 0" ref="summary" @finishCalculate="finishCalculate"/>
                            <pond-report-item :crop="item" :search="search" v-else @update="updateFromTab" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-card-text>
            <v-card-actions v-if="!print">
                <v-spacer/>

                <v-btn color="primary" @click="onPrint">
                    {{ $t("lang.report.print") }}
                </v-btn>
                <v-btn color="info" @click="onSend">
                    {{ $t("lang.report.send") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <send-report ref="sendDlg" @send="onSendTo"/>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "../../shared/message";
    import moment from "moment";
    import PondReportItem from "./PondReportItem";
    import PondReportSummary from "./PondReportSummary";
    import SendReport from "./SendReport";
    import {Validator} from "vee-validate";

    export default {
        name: "pond-report",
        components: {SendReport, PondReportSummary, PondReportItem},
        data: () => {
            return {
                print:false,
                formName: "Báo cáo tình trạng ao",
                envItem: null,
                visibleEnvDialog: false,
                lstIndex: [],
                lstPond: [],
                seedNumber:[],
                lstArea: [],
                lstCrop: [],
                crop: null,
                cropSelected:[],
                lstItem: [],
                search: {
                    fromDate: (new Date()).setDate(new Date().getDate() - 7),
                    toDate: new Date()
                },
                g: null,
                reportData:{},
                saveSession:new Date().getTime(),
                flagCalculate:0,
            };
        },

        created() {
            this.getEnvIndex();
            this.getArea();
            if (this.$route.params.print != undefined) {
                this.print = true;
                this.search.areaId = parseInt(this.$route.params.areaId);
                if (this.$route.params.pondId == undefined || this.$route.params.pondId == null || this.$route.params.pondId == "" || this.$route.params.pondId == "undefined") {
                    this.search.pondId = null;
                } else {
                    this.search.pondId = JSON.parse(this.$route.params.pondId);
                }
                if (this.$route.params.cropId == undefined || this.$route.params.cropId == null || this.$route.params.cropId == "" || this.$route.params.cropId == "undefined") {
                    this.search.cropId = null;
                } else {
                    this.search.cropId = JSON.parse(this.$route.params.cropId);

                }

                this.search.fromDate = this.$route.params.fromDate;
                this.search.toDate = this.$route.params.toDate;
                this.getPondSearchList();
                this.getCropSearchList();
            }
        },

        mounted(){
            Validator.extend("endDateAfterStart", {
                validate: (value, {otherValue}) => {
                    // console.log("validate");
                    // console.log(value);
                    // console.log(otherValue);
                    // console.log(this.search.fromDate);
                    let mm = moment(value).hour(23).minute(59).second(59);
                    let valid = mm.isSameOrAfter(this.search.fromDate); // false
                    // console.log(valid);
                    // console.log("--- end validate --- ");
                    return {
                        valid: valid,
                        data: {
                            message: "Đến ngày phải sau Từ ngày"
                        }
                    };
                    ;
                },
                getMessage: (field, params, data) => {
                    return "Đến ngày phải sau Từ ngày";
                }
            });
        },

        methods: {
            maxDay(){
                let day = moment().format("YYYY-MM-DD");
                // console.log(day);
                return day;
            },

            shrimpAgeByDate(crop, calculateDate) {
                let shrimpAge = 0;
                let dropDate = '';
                if (parseInt(crop.pondParent) > 0 && crop.dropDateParent != '' && crop.dropDateParent != null) {
                    dropDate = moment(String(crop.dropDateParent));
                } else if (crop.dropDate != '' && crop.dropDate != null) {
                    dropDate = moment(String(crop.dropDate));
                }
                // console.log(dropDate);
                if (dropDate != '') {
                    let calculateDateMM = moment(calculateDate);
                    let endDate = moment(calculateDate);
                    if (crop.endDate) {
                        endDate = moment(String(crop.endDate));
                        if (endDate > calculateDateMM) endDate = calculateDateMM;
                    }
                    if (endDate > dropDate) {
                        let dates = endDate.diff(dropDate, "days");
                        if (dates >= 0) {
                            shrimpAge = dates;
                        }
                    }
                }
                return shrimpAge;

            },

            getG() {
                const search = this.search;

                if (this.search.areaId == undefined || this.search.areaId == null) {
                    message.error("Chưa chọn khu");
                    return;
                }
                
                if(search.pondId.length == 0){
                    search.pondId = null;
                }
                if(search.cropId.length == 0){
                    search.cropId = null;
                }

                axios.post(
                    process.env.VUE_APP_API_URL + "/gindex/search", search
                ).then(
                    (data) => {
                        if (data.items && data.items.length > 0) {
                            this.g = data.items[0];
                            // console.log(this.g);
                            if (this.g.g1 != undefined && this.g.g1 != null) {
                                this.g.g1Index = JSON.parse(this.g.g1);
                            } else {
                                this.g.g1Index = {};
                            }

                            if (this.g.g2 != undefined && this.g.g2 != null) {
                                this.g.g2Index = JSON.parse(this.g.g2);
                            } else {
                                this.g.g2Index = {};
                            }
                            //
                            //
                            //
                            for (let i = 0; i < this.lstIndex.length; i++) {
                                if (this.g.g1Index[this.lstIndex[i].envId] == undefined || this.g.g1Index[this.lstIndex[i].envId] == null) {
                                    this.g.g1Index[this.lstIndex[i].envId] = {};
                                }
                                if (this.g.g2Index[this.lstIndex[i].envId] == undefined || this.g.g2Index[this.lstIndex[i].envId] == null) {
                                    this.g.g2Index[this.lstIndex[i].envId] = {};
                                }
                            }
                        }
                    }
                );
            },

            checkInRange(number, min, max) {
                if (isNaN(number)) {
                    return false;
                }
                if((min == undefined || min == null || min == "" || isNaN(min)) && (max == undefined || max == null || max == "" || isNaN(max))){
                    return false;
                }
                if (min != undefined && min != null && min !== "") {
                    if (min > number) {
                        return false;
                    }
                }
                if (max != undefined && max != null && max !== "") {
                    if (max < number) {
                        return false;
                    }
                }
                return true;

            },

            changeCrop() {
                this.cropSelected = [
                    {cropId:0,name:"Tổng hợp"}
                ]
                console.log(this.search);
                if(this.search.cropId == undefined || this.search.cropId == null){
                    return;
                }


                for(let i=0;i<this.search.cropId.length;i++){
                    for(let j=0;j<this.lstCrop.length;j++){
                        if(this.lstCrop[j].cropId == this.search.cropId[i]){
                            this.cropSelected.push(this.lstCrop[j]);
                            break;
                        }
                    }
                }

                for(let key in this.reportData){
                    let bHas =false;
                    for(let i=0;i<this.search.cropId.length;i++){
                        if(key == this.search.cropId[i]){
                            bHas = true;
                        }
                    }
                    if(!bHas){
                        delete this.reportData[key];
                    }
                }
                // console.log(this.reportData);
                if (this.$refs.summary != undefined) {
                    this.$refs.summary[0].reCalculate();
                }
            },

            getEnvIndex() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/envIndex/search?pageSize=-1&page=0", {}
                ).then(
                    (data) => {
                        this.lstIndex = data.items;
                    }
                );
            },

            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/myArea"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea = data;
                        }
                    }
                );
            },

            getSeedNumber() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByType?type=SEEDNUMBER"
                )
                    .then(
                        (data) => {
                            if (data.length > 0) {
                                this.seedNumber = data;
                                // let itemFields = this.fields.filter(function (e) {
                                //     return e.name == "seedNumber";
                                // });
                                // if (itemFields != undefined && itemFields.length > 0) {
                                //     itemFields[0].items = data;
                                // }
                            }
                        }
                    );
            },

            getPondSearchList() {
                this.search.pondId = [];
                if(!this.print){
                  this.search.cropId = [];
                  this.cropSelected = []
                }

                axios.post(
                    process.env.VUE_APP_API_URL + "/pond/search?&pageSize=-1&page=1", {areaId: this.search.areaId}
                ).then(
                    (data) => {
                        // console.log(data);
                        if (data.count > 0) {
                            this.lstPond = data.items;
                        }
                    }
                );
                this.getCropSearchList();
                this.getG();
            },

            getCropSearchList() {
                let ob = {
                    pondAreaId: this.search.areaId,
                    pondParentIds: JSON.stringify(this.search.pondId),
                    status: 1
                };
                if(this.search.pondId.length == 0){
                    ob.pondParentIds = null;
                }
                axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", ob
                ).then(
                    (data) => {
                        if (data.items) {
                            this.lstCrop = data.items;
                            // if (this.search.pondId != null && this.search.pondId > 0) {
                            //     this.cropSelected.push(...data.items);
                            //     if (data.items.length > 0) {
                            //         const cropIds = [];
                            //         for (let i = 0; i < data.items.length; i++) {
                            //             cropIds.push(data.items[i].cropId);
                            //         }
                            //         this.search.cropId = cropIds;
                            //     }
                            // }
                            this.changeCrop();
                        }
                    }
                );
            },
            finishCalculate(){
              if (this.print) {
                if(this.flagCalculate == this.cropSelected.length - 2){
                  this.$nextTick(
                      () => {
                        window.print();
                      }
                  )
                }

              }
            },

            updateFromTab(tabData){
                // console.log("before update");
                this.reportData[tabData.crop.cropId] = tabData;
                // console.log("after update");
                // console.log(this.reportData);
                this.$refs.summary[0].reCalculate();
                this.flagCalculate++;
            },

            onSend(){
                this.$refs.sendDlg.onShow();
            },

            generateReportURL(){
                let url = "/print/pondReport/1/";
                url += this.search.areaId + "/";
                url += JSON.stringify(this.search.pondId) + "/";
                url += JSON.stringify(this.search.cropId) + "/";
                url += this.search.fromDate + "/";
                url += this.search.toDate + "/";
                return url;
            },

            onSendTo(user) {
                // console.log('--- send to user');
                // console.log(user);
                let url =process.env.VUE_APP_FRONTEND_URL+"/#"+ this.generateReportURL();
                let report = {
                    reportType:'Báo cáo tình trạng ao',
                    userId:user.userId,
                    url:url
                };
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",report).then(
                    data=>{
                        if(data.success){
                            message.success("Gửi thành công");
                            this.$refs.sendDlg.onCancel();
                        } else {
                            message.error("Gửi không thành công");
                        }
                    }
                );
            },

            onPrint() {
                let url = this.generateReportURL();
                this.$router.push(url);
            }

        },

        destroyed() {
        },
    };
</script>

<style>
    .indicator {
        margin: 5px 5px 5px 0px;
        padding: 5px;
        display: inline-block;
        border: 1px solid gray;
        width: fit-content;
    }

    .G2 {
        background-color: gold;
    }

    .G3 {
        background-color: crimson;
    }
</style>